import { createContext } from 'react';
export const MediaTimelineCapabilitiesContext = /*#__PURE__*/createContext({
  clipEditor: undefined
});
export const MediaTimelineCapabilitiesProvider = MediaTimelineCapabilitiesContext.Provider;